
import APP_CONFIG from '../../app.config';

export const getNearestLocationCity = (latitude, longitude, $http, $httpParamSerializer) => {
  const queryParams = $httpParamSerializer({
    latitude: latitude,
    longitude: longitude
  })

  const baseUrl = `${APP_CONFIG.be}/locations/city_of_closest_active_location`;
  const url = `${baseUrl}/?${queryParams}`;
  return $http.get(url);
}



// WEBPACK FOOTER //
// ./src/app/common/location/utils.js